import { Typography, Paper, Box, Stack, useTheme } from "@mui/material"
import { useNavigate, useOutletContext } from "react-router-dom"
import React, { useState } from "react"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as CalcIcon } from "src/v2/assets/icons/calc-icon.svg"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import CaracteristicasSection from "../componentes/CaracteristicasSection"
import DatasSection from "../componentes/DatasSection"
import JurosCorrecaoSection from "../componentes/JurosCorrecaoSection"
import FatorArredondamentoSection from "../componentes/FatorArredondamentoSection"
import FormActions from "../../components/FormActions"
import { caracteristicasFields } from "../componentes/CaracteristicasSection/constants"
import { datasFields } from "../componentes/DatasSection/constants"
import { jurosCorrecaoFields } from "../componentes/JurosCorrecaoSection/constants"
import { fatorArredondamentoFields } from "../componentes/FatorArredondamentoSection/constants"

export const ParametrosPage = () => {
    const theme = useTheme()
    const navigate = useNavigate()

    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
    const { caracteristicaState } = useOutletContext() || {}
    // se tiver ID, é produção (true). Se não tiver, é temporário (false).
    const isPublished = Boolean(caracteristicaState?.ID)


    const sectionScrollMargin = 16

    const generateInitialState = (fields) => {
        return fields.reduce((acc, field) => {
            acc[field.name] = field.defaultValue ?? "" // Usa default ou vazio
            return acc
        }, {})
    }

    const [formData, setFormData] = useState({
        caracteristicas: generateInitialState(caracteristicasFields),
        datas: generateInitialState(datasFields),
        jurosCorrecao: generateInitialState(jurosCorrecaoFields),
        fatorArredondamento: generateInitialState(fatorArredondamentoFields)
    })


    const setSectionField = (section, key, value) => {
        setFormData((prev) => ({
            ...prev,
            [section]: {
                ...prev[section],
                [key]: value,
            },
        }))
    }

    const handleSave = () => {
        console.log("Salvando dados...", formData)
        // Aqui entraria a chamada da api
    }

    const handlePublish = () => {
        console.log("Publicando evento...")
    }

    const handleDelete = () => {
        console.log("Deletando registro...")
        setDeleteConfirmOpen(false)
        navigate(-1) // volta para a tela anterior após deletar
    }

    return (
        <Stack spacing={2} sx={{ mt: 3, pb: 2 }}>
            <Paper
                square
                sx={{
                    p: 4,
                    backgroundColor: "background.paper",
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5
                }}
            >
                <Typography
                    sx={{
                        mb: 3,
                        fontWeight: 400,
                        fontSize: "14px",
                        textTransform: 'uppercase',
                        color: 'white.main'
                    }}>
                    Projetar
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2
                    }}>
                    <Typography sx={{ color: 'white.main', maxWidth: '70%' }}>
                        Com base nos Parametros abaixo, gostaria que o sistema projete o fluxo dos Eventos Ordinarios
                    </Typography>

                    <Box>
                        <ButtonWithIcon icon={<CalcIcon />} size="md">
                            PROJETAR
                        </ButtonWithIcon>
                    </Box>
                </Box>

            </Paper>
            <Box
                sx={{
                    marginTop: { xs: -4, md: -14.5 },
                    paddingBottom: 0,
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    px: { xxxs: 3, md: 3, lg: 0 },
                }}
            >
                <div data-section="caracteristicas" style={{ scrollMarginTop: sectionScrollMargin }}>
                    <CaracteristicasSection
                        state={formData.caracteristicas}
                        setSectionField={setSectionField}
                        defaultOpen={true} // aparece aberto
                    />
                </div>

                <div data-section="datas" style={{ scrollMarginTop: sectionScrollMargin }}>
                    <DatasSection
                        state={formData.datas}
                        setSectionField={setSectionField}
                    />
                </div>

                <div data-section="jurosCorrecao" style={{ scrollMarginTop: sectionScrollMargin }}>
                    <JurosCorrecaoSection
                        state={formData.jurosCorrecao}
                        setSectionField={setSectionField}
                    />
                </div>

                <div data-section="fatorArredondamento" style={{ scrollMarginTop: sectionScrollMargin }}>
                    <FatorArredondamentoSection
                        state={formData.fatorArredondamento}
                        setSectionField={setSectionField}
                    />
                </div>

                <Box sx={{ mx: { xxxs: -3, md: -3, lg: 0 }, mt: 2 }}>
                    <FormActions
                        showBack
                        onBack={() => navigate(-1)}

                        onDelete={() => setDeleteConfirmOpen(true)}
                        deleteOpen={deleteConfirmOpen}
                        setDeleteOpen={setDeleteConfirmOpen}
                        onConfirmDelete={handleDelete}


                        showSave={!isPublished}
                        onSave={handleSave}

                        onPublish={handlePublish}
                        publishLabel={isPublished ? "SALVAR E PUBLICAR" : "PUBLICAR"}
                        publishIcon={<CheckIcon />}

                        theme={theme}
                    />
                </Box>
            </Box>

        </Stack>

    )
}